import React, { useContext, useState } from 'react';
import { BrowserRouter, Switch, Route } from "react-router-dom";

import Front from "./page/Front";
// user
import UserSettingsPages from "./page/UserSettingsPages";
// match
import MatchContainer from "./page/match/MatchContainer";
// search
import SearchPage from "./page/SearchPage";

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';

import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MainListItems from './menu/MainListItems';
import GridOnTwoToneIcon from '@material-ui/icons/GridOnTwoTone';
import ImageSearchTwoToneIcon from '@material-ui/icons/ImageSearchTwoTone';

// themes
// import { themes } from '../theme/Themes'
// user adatok
import UserContext from "../context/UserContext";

const drawerWidth = 240;



export default function Dashboard(props) {
  const { setLogin } = props;

  const user = useContext(UserContext);

  const [open, setOpen] = useState(false);

  console.log('dashboord');
  //--------------
  //----------------------
  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
    },
    toolbar: {
      paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px',
      ...theme.mixins.toolbar,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      // background: themes[user.theme].palette.primary.dark

    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    menuButtonHidden: {
      display: 'none',
    },
    title: {
      flexGrow: 1,
    },
    drawerPaper: {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      background: `${theme.palette.primary.dark}80`,
      color: `${console.log(theme.palette.primary.dark)}`,
      // font: `${console.log(theme.palette.primary.dark)}`
      // background: `${themes[user.theme].palette.primary.dark}80`,
    },
    drawerPaperClose: {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9),
      },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    fixedHeight: {
      height: 240,
    },
    item: {
      marginLeft: '20px'
    }
  }));
  //-----------

  const classes = useStyles();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  function hangleLogoutClick(e) {
    // remove storage token és userId
    localStorage.removeItem('TS');
    console.log('logout');
    // login false
    setLogin(false);

  }

  return <div className={classes.root}>
    <CssBaseline />
    <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
      <Toolbar className={classes.toolbar}>
        {console.log('---toolbar')}
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
        >
          <MenuIcon />
        </IconButton>
        <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
          Traveling Salesman
          </Typography>
        <IconButton color="inherit">
          <Badge badgeContent={17} color="secondary">
            <GridOnTwoToneIcon />
          </Badge>
        </IconButton>
        <IconButton color="inherit">
          <Badge badgeContent={3} color="secondary">
            <ImageSearchTwoToneIcon />
          </Badge>
        </IconButton>
        <IconButton color="inherit">
          <Badge badgeContent={40} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        {user.user && <div className={classes.item}>{[user.user.lastname, user.user.middleName, user.user.firstname].join(' ')}</div>}
        <Button
          variant="outlined"
          size="small"
          className={classes.item}
          onClick={hangleLogoutClick}
        >
          Kilépés
          </Button>
      </Toolbar>
    </AppBar>
    <BrowserRouter>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>
          <MainListItems />
        </List>
        <Divider />
      </Drawer>
      <main className={classes.content} >
        <div className={classes.appBarSpacer} />
        <Switch>
          <Route exact path="/">
            <Front />
          </Route>
          <Route exact path="/user/settings/:id">
            <UserSettingsPages />
          </Route>
          <Route
            exact
            path={["/match", "/match/:id"]}
            component={MatchContainer}
          />
          <Route exact path="/search">
            <SearchPage />
          </Route>
        </Switch>
      </main>
    </BrowserRouter>
  </div >
}
